<template>
  <div class="most-popular-questions">
    <translate tag="h2">Most popular questions</translate>
    <translate
      >Before you contact us, please type your question below to see if it has
      already been answered.</translate
    >
    <client-only>
      <algolia-search :categories="algoliaCategories" />
    </client-only>

    <lazy-page-part
      v-if="contactStore.isCustomerTypeCustomer"
      part-key="about_contact_customer"
      wrapper-tag="section"
    />
    <lazy-page-part
      v-if="contactStore.isCustomerTypeSiteOwner"
      part-key="about_contact_manager"
      wrapper-tag="section"
    />
  </div>
</template>

<script setup lang="ts">
import ALGOLIA_CATEGORIES from '~/json/algoliaCategories.json'

const contactStore = useContactStoreSetup(usePinia())
const algoliaCategories = computed(() => {
  if (contactStore.isCustomerTypeCustomer) {
    return ALGOLIA_CATEGORIES.customer
  }
  if (contactStore.isCustomerTypeSiteOwner) {
    return ALGOLIA_CATEGORIES.owner
  }
  if (contactStore.isCustomerTypeOther) {
    return [...ALGOLIA_CATEGORIES.customer, ...ALGOLIA_CATEGORIES.owner]
  }
  return []
})
</script>

<style scoped>
.most-popular-questions {
  margin-bottom: 2em;
}

.ais-InstantSearch {
  margin: 1em 0;
}

:deep(p) {
  margin: 0 0 0.5em 0;
  line-height: 1.4em;
}
</style>
